// extracted by mini-css-extract-plugin
module.exports = {"mapContainer":"Map_mapContainer__2bLH2","map_icon":"Map_map_icon__xrBqm"};